module.exports = __webpack_public_path__ + "static/media/Bhagyashree_Patil.41e8c614.jpg";